import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';

import { doBetStore, gameStore } from '../../../store';
import { BetButton } from '../../../components/betButton';
import { autoBetDataKeys, fightersList } from '../../../enums/uiConfig';
import { AutoBetAutoCashOutSection } from '../autoBetAutoCashOutSection';
import { BetInputQuickButtons } from '../../../components/betInputQuickButtons';

export const BetSectionMain = observer(
  ({
    t,
    onBlur,
    isDemo,
    limits,
    balance,
    isStart,
    onChange,
    betAmount,
    fighterData,
    autoBetData,
    doBetSender,
    isBetsClosed,
    isAutoCashOut,
    activeFreeBet,
    autoCashOutOdd,
    resetDoBetData,
    changeBetAmount,
    handleOpenNumPad,
    showNotification,
    handleChangeAutoBet,
    isNotHaveActiveBets,
    currentFighterSection,
    handleChangeInputValue,
    handleSwitchAutoCashOut,
    isDisabledFighterSection,
    updateIsDisabledBetSection,
    handleChangeAutoCashOutInput,
    handleChangeAutoCashOutInputValue,
  }) => {
    const [isValidatedAmountForManual, setIsValidatedAmountForManual] = useState(false);
    const [isValidatedAutoCashOutOdd, setIsValidatedAutoCashOutOdd] = useState(false);

    const decidedCallBackCall = (callback, isAutoCashOutInput = false) => {
      if ((isAutoCashOutInput && isValidatedAutoCashOutOdd) || isValidatedAmountForManual) {
        if (isAutoCashOutInput && isValidatedAutoCashOutOdd) {
          setIsValidatedAutoCashOutOdd(false);
        } else {
          setIsValidatedAmountForManual(false);
        }
      } else {
        callback();
      }
    };

    useEffect(() => {
      if (!gameStore.oddData) {
        doBetStore.autoBetData.forEach((item) => {
          if (item.isAutoBet && item.autoBetCount === 0) {
            doBetStore.updateAutoBetData(autoBetDataKeys.isAutoBet, false, item.fighterNumber);
          }
        });
      }
    }, [doBetStore.autoBetData, gameStore.oddData]);

    /* ADD Class "fighter1, fighter2, fighter3" */
    return (
      <div
        className={`bet-inner-container ${fightersList[currentFighterSection].className} 
        ${
          fighterData.betId &&
          !autoBetData.isAutoBet &&
          !autoBetData.autoBetCount &&
          !isNotHaveActiveBets
            ? 'passive'
            : ''
        }
        `}
      >
        <div
          className={`bet-main-container ${
            isMobile() && fighterData.betId && !isNotHaveActiveBets ? 'disabled' : ''
          }`}
        >
          <AutoBetAutoCashOutSection
            t={t}
            isDemo={isDemo}
            isStart={isStart}
            betAmount={betAmount}
            maxWin={limits.maxWin}
            fighterData={fighterData}
            autoBetData={autoBetData}
            doBetSender={doBetSender}
            isBetsClosed={isBetsClosed}
            isAutoCashOut={isAutoCashOut}
            activeFreeBet={activeFreeBet}
            autoCashOutOdd={autoCashOutOdd}
            handleOpenNumPad={handleOpenNumPad}
            handleChangeAutoBet={handleChangeAutoBet}
            currentFighterSection={currentFighterSection}
            handleSwitchAutoCashOut={handleSwitchAutoCashOut}
            isDisabledFighterSection={isDisabledFighterSection}
            updateIsDisabledBetSection={updateIsDisabledBetSection}
            handleChangeAutoCashOutInput={handleChangeAutoCashOutInput}
            handleChangeAutoCashOutInputValue={handleChangeAutoCashOutInputValue}
          />
          <BetInputQuickButtons
            t={t}
            onBlur={onBlur}
            limits={limits}
            balance={balance}
            onChange={onChange}
            betAmount={betAmount}
            fighterData={fighterData}
            autoBetData={autoBetData}
            isBetsClosed={isBetsClosed}
            isAutoCashOut={isAutoCashOut}
            activeFreeBet={activeFreeBet}
            resetDoBetData={resetDoBetData}
            autoCashOutOdd={autoCashOutOdd}
            changeBetAmount={changeBetAmount}
            showNotification={showNotification}
            handleOpenNumPad={handleOpenNumPad}
            decidedCallBackCall={decidedCallBackCall}
            currentFighterSection={currentFighterSection}
            handleChangeInputValue={handleChangeInputValue}
            isDisabledFighterSection={isDisabledFighterSection}
            isValidatedAmountForManual={isValidatedAmountForManual}
            setIsValidatedAmountForManual={setIsValidatedAmountForManual}
          />
          <BetButton
            t={t}
            autoBetData={autoBetData}
            fighterData={fighterData}
            decidedCallBackCall={decidedCallBackCall}
            isNotHaveActiveBets={isNotHaveActiveBets}
            currentFighterSection={currentFighterSection}
          />
        </div>
      </div>
    );
  }
);
